import { Injectable } from '@angular/core';
import { SimpleMQ } from 'ng2-simple-mq';
import { CommonService } from './common.service';
import { DbService } from './db.service';
import { LocaleService } from './locale.service';
import { ContribuentiService } from './contribuenti.service';
import { UtentiService } from './utenti.service';
import { ComuniService } from './comuni.service';
import { AvanzaPraticheService } from './avanza-pratiche.service';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import 'rxjs/Rx';
import * as _ from 'lodash';

declare var Notification: any; // NOTIFICHE BROWSER

@Injectable()
export class DataService {
	private contribuentiService: ContribuentiService;
	private utentiService: UtentiService;
	private comuniService: ComuniService;
	private avanzaPraticheService: AvanzaPraticheService;

	// VARIABILI GLOBALI
	public detailMode: boolean = true;
	public loading: boolean = false;
	public pageOpened: string = '';
	public flowInit: boolean = true;
	public appLocked: boolean = false;
	public lockReason: string = '';
	public titlePage: string = '';

	//	MESSAGE
	public showMessage: boolean = false;
	public messageTitle: string = '';
	public messageContent: string = '';
	// LOADER
	public showLoader: boolean = false;
	public loaderTitle: string = '';
	public loaderContent: string = '';
	// CONFIRM
	public showConfirm: boolean = false;
	public confirmTitle: string = '';
	public confirmContent: string = '';
	public confirmResponse: boolean = null;
	public callbackConfirmYes: any = null;
	public callbackConfirmNo: any = null;

	//	VARIABILI GENERALI
	private defaultStates: any[] = [];
	private _defaultStatesSource = new BehaviorSubject<any[]>([]);
	public defaultStates$ = this._defaultStatesSource.asObservable();

	public notificheSistema: any[] = [];
	public _notificheSistemaSource = new BehaviorSubject<any[]>([]);
	public notificheSistema$ = this._notificheSistemaSource.asObservable();

	private interessiLegali: any[] = [];
	private _interessiLegaliSource = new BehaviorSubject<any[]>([]);
	public interessiLegali$ = this._interessiLegaliSource.asObservable();

	private tipiTributo: any[] = [];
	private _tipiTributoSource = new BehaviorSubject<any[]>([]);
	public tipiTributo$ = this._tipiTributoSource.asObservable();

	private tipiFase: any[] = [];
	private _tipiFaseSource = new BehaviorSubject<any[]>([]);
	public tipiFase$ = this._tipiFaseSource.asObservable();

	private tipiDirittiOneriRiscossione: any[] = [];
	private _tipiDirittiOneriRiscossioneSource = new BehaviorSubject<any[]>([]);
	public tipiDirittiOneriRiscossione$ = this._tipiDirittiOneriRiscossioneSource.asObservable();

	private tipiSpedizione: any[] = [];
	private _tipiSpedizioneSource = new BehaviorSubject<any[]>([]);
	public tipiSpedizione$ = this._tipiSpedizioneSource.asObservable();

	private tipiNotifica: any[] = [];
	private _tipiNotificaSource = new BehaviorSubject<any[]>([]);
	public tipiNotifica$ = this._tipiNotificaSource.asObservable();

	private esitiNotifica: any[] = [];
	private _esitiNotificaSource = new BehaviorSubject<any[]>([]);
	public esitiNotifica$ = this._esitiNotificaSource.asObservable();

	private qualificheAssociato: any[] = [];
	private _qualificheAssociatoSource = new BehaviorSubject<any[]>([]);
	public qualificheAssociato$ = this._qualificheAssociatoSource.asObservable();

	private dirittiOneriRiscossione: any[] = [];
	private _dirittiOneriRiscossioneSource = new BehaviorSubject<any[]>([]);
	public dirittiOneriRiscossione$ = this._dirittiOneriRiscossioneSource.asObservable();

	private ruoli: any[] = [];
	private _ruoliSource = new BehaviorSubject<any[]>([]);
	public ruoli$ = this._ruoliSource.asObservable();

	private servizi: any[] = [];
	private _serviziSource = new BehaviorSubject<any[]>([]);
	public servizi$ = this._serviziSource.asObservable();

	// VARIABILI PER COMUNE
	private flows: any = null;
	private _flowsSource = new BehaviorSubject<any>(null);
	public flows$ = this._flowsSource.asObservable();

	private activeFlow: any = null;
	private _activeFlowSource = new BehaviorSubject<any>(null);
	public activeFlow$ = this._activeFlowSource.asObservable();

	private statesDict: any = {};
	private statesDictIndex: any[] = [];
	private _statesDictSource = new BehaviorSubject<any>({});
	public statesDict$ = this._statesDictSource.asObservable();

	private pratiche: any[] = [];
	private _praticheSource = new BehaviorSubject<any[]>([]);
	public pratiche$ = this._praticheSource.asObservable();

	private praticheDettagli: any[] = [];
	private _praticheDettagliSource = new BehaviorSubject<any[]>([]);
	public praticheDettagli$ = this._praticheDettagliSource.asObservable();

	private atti: any[] = [];
	private _attiSource = new BehaviorSubject<any[]>([]);
	public atti$ = this._attiSource.asObservable();

	private notifiche: any[] = [];
	private _notificheSource = new BehaviorSubject<any[]>([]);
	public notifiche$ = this._notificheSource.asObservable();

	private pagamenti: any[] = [];
	private _pagamentiSource = new BehaviorSubject<any[]>([]);
	public pagamenti$ = this._pagamentiSource.asObservable();

	private canaliPagamento: any[] = [];
	private _canaliPagamentoSource = new BehaviorSubject<any[]>([]);
	public canaliPagamento$ = this._canaliPagamentoSource.asObservable();

	private emissioni: any[] = [];
	private _emissioniSource = new BehaviorSubject<any[]>([]);
	public emissioni$ = this._emissioniSource.asObservable();

	private messiNotificatori: any[] = [];
	private _messiNotificatoriSource = new BehaviorSubject<any[]>([]);
	public messiNotificatori$ = this._messiNotificatoriSource.asObservable();

	private interessiMoratori: any[] = [];
	private _interessiMoratoriSource = new BehaviorSubject<any[]>([]);
	public interessiMoratori$ = this._interessiMoratoriSource.asObservable();

	private responsabiliTributo: any[] = [];
	private _responsabiliTributoSource = new BehaviorSubject<any[]>([]);
	public responsabiliTributo$ = this._responsabiliTributoSource.asObservable();

	private templatesGruppi: any[] = [];
	private _templatesGruppiSource = new BehaviorSubject<any[]>([]);
	public templatesGruppi$ = this._templatesGruppiSource.asObservable();

	private beniMobili: any[] = [];
	private _beniMobiliSource = new BehaviorSubject<any[]>([]);
	public beniMobili$ = this._beniMobiliSource.asObservable();

	private beniImmobili: any[] = [];
	private _beniImmobiliSource = new BehaviorSubject<any[]>([]);
	public beniImmobili$ = this._beniImmobiliSource.asObservable();

	private locatari: any[] = [];
	private _locatariSource = new BehaviorSubject<any[]>([]);
	public locatari$ = this._locatariSource.asObservable();

	private datoriLavoro: any[] = [];
	private _datoriLavoroSource = new BehaviorSubject<any[]>([]);
	public datoriLavoro$ = this._datoriLavoroSource.asObservable();

	private contiCorrenti: any[] = [];
	private _contiCorrentiSource = new BehaviorSubject<any[]>([]);
	public contiCorrenti$ = this._contiCorrentiSource.asObservable();

	private logPratiche: any[] = [];
	private _logPraticheSource = new BehaviorSubject<any[]>([]);
	public logPratiche$ = this._logPraticheSource.asObservable();

	private logPraticheDettagli: any[] = [];
	private _logPraticheDettagliSource = new BehaviorSubject<any[]>([]);
	public logPraticheDettagli$ = this._logPraticheDettagliSource.asObservable();

	private notificheUtente: any[] = [];
	private notificheUtenteDict: any = {};
	private notificheUtenteDictIndex: any[] = [];
	private _notificheUtenteDictSource = new BehaviorSubject<any[]>([]);
	public notificheUtenteDict$ = this._notificheUtenteDictSource.asObservable();

	private userByComuneSync: Subscription;
	private comuniDisponibili: any[] = [];
	private comuniDisponibiliSync: Subscription;

	constructor(private commonService: CommonService, private smq: SimpleMQ) {
		console.log("SRV|DS - ALIVE!");
		this.smq.subscribe('data', e => this.receiveMsg(e));
		this.contribuentiService = new ContribuentiService(commonService, smq);
		this.utentiService = new UtentiService(commonService, smq);
		this.comuniService = new ComuniService(commonService, smq);
		this.avanzaPraticheService = new AvanzaPraticheService(commonService, smq);
		this.InitService();
	}

	receiveMsg(m) {
		console.log('SRV|DS - receiveMsg:', m);
		if(m){
			let msgSender = m.sender;
			let msgType = m.type;
			let msgKey = m.key;
			let msgValue = m.value;
			switch(msgType){
				case 'richiesta':
					switch(msgKey){
						case 'pageOpened':
							this.sendMsg(msgSender, 'risposta', msgKey, this.pageOpened);
							break;
						default:
							console.log('SRV|DS - receiveMsg: class', this);
					}
					break;
				case 'cambioComune':{
					//console.log('SRV|DS - cambioComune:', msgKey, msgValue);
					if(msgKey == 'idComune'){
						this.cambioComune(msgValue);
					}
					break;
				}
				case 'setLoading':{
					//console.log('SRV|DS - setLoading:', msgKey, msgValue);
					if(msgKey == 'loading'){
						this.setLoading(msgValue);
					}
					break;
				}
				case 'refreshData':{
					//console.log('SRV|DS - refreshData:', msgKey, msgValue);
					if(msgKey == 'what'){
						this.refreshData(msgValue);
					}
					break;
				}
				default:

			}
		}
	}

	sendMsg(name: string, type: any, key: any, value: any = null) {
		// Publish to queue name
		let m = {
			sender: 'data',
			type: type,
			key: key,
			value: value,
		};
		console.log('SRV|DS - sendMsg:', m);
		this.smq.publish(name, m);
	}

	InitService(){
		// Notifiche
		this.commonService.getDB().socketService.on('notificaSistema', (notifica) => {
			console.log('notificaSistema',notifica);
			this.addNotificaSistema(notifica);
		});

		this.userByComuneSync = this.utentiService.userByComune$.subscribe(
			userByComune => {
				//console.log("SRV|DS - userByComune", userByComune);
				if(userByComune){
					if(userByComune.idMunicipalityAuthorized || userByComune.userComplete.id_anagrafica){
						console.log("SRV|DS - getComuniDisponibili", userByComune);
						this.comuniService.getComuniDisponibili(userByComune);
					}
				}
			});

		this.comuniDisponibiliSync = this.comuniService.comuniDisponibili$.subscribe(
			comuniDisponibili => {
				this.comuniDisponibili = comuniDisponibili;
				this.getNotificheSistema()
			});
	}

	// INIZIO GESTIONE VARIABILI GENERALI
	loadGeneral(pageOpened: any) {
		console.log("SRV|DS - LOAD GENERAL", pageOpened);
		this.pageOpened = pageOpened;
		this.postLoadGeneral();
	}

	postLoadGeneral(){
		this.getDefaultStates();
		this.getInteressiLegali();
		this.getTipiTributo();
		this.getTipiFase();
		this.getTipiDirittiOneriRiscossione();
		this.getTipiSpedizione();
		this.getTipiNotifica();
		this.getEsitiNotifica();
		this.getQualificheAssociato();
		this.getRuoli();
		this.getServizi();
		this.getTemplatesGruppi();
	}

	/*	Service Secondari	*/
	getCommon(){
		return this.commonService;
	}

	getUtentiService(){
		return this.utentiService;
	}

	getComuniService(){
		return this.comuniService;
	}

	getContribuentiService(){
		return this.contribuentiService;
	}

	getAvanzaPraticheService(){
		return this.avanzaPraticheService;
	}

	navigate(url: any[]){
		this.commonService.getRouter().navigate(url);
	}

	navigateByUrl(urlString: string){
		this.commonService.getRouter().navigateByUrl(urlString);
	}

	/*	Chiamate a DB Service	*/
	getDefaultStates() {
		this.commonService.getDB().getElementsByTable('stati')
			.subscribe(
				data => { this.defaultStates = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					for(let stato of this.defaultStates){
						stato.atto = Number(stato.atto);
						stato.bollettino = Number(stato.bollettino);
						stato.rate = Number(stato.rate);
					}
					this._defaultStatesSource.next(this.defaultStates);
					console.log("SRV|DS - DEFAULT STATES:", this.defaultStates);
				}
			);
	}

	getTipiTributo(){
		this.commonService.getDB().getElementsByTable('tipi_tributo')
			.subscribe(
				data => { this.tipiTributo = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._tipiTributoSource.next(this.tipiTributo);
					console.log("SRV|DS - TIPITRIBUTO:", this.tipiTributo);
				}
			);
	}

	getTipiFase(){
		this.commonService.getDB().getElementsByTable('tipi_fase')
			.subscribe(
				data => { this.tipiFase = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._tipiFaseSource.next(this.tipiFase);
					console.log("SRV|DS - TIPIFASE:", this.tipiFase);
				}
			);
	}

	getInteressiLegali() {
		this.commonService.getDB().getElementsByTable('interessi_legali')
			.subscribe(
				data => { this.interessiLegali = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._interessiLegaliSource.next(this.interessiLegali);
					console.log("SRV|DS - INTERESSI LEGALI:", this.interessiLegali);
				}
			);
	}

	getTipiDirittiOneriRiscossione(){
		this.commonService.getDB().getElementsByTable('tipi_diritti_oneri')
			.subscribe(
				data => { this.tipiDirittiOneriRiscossione = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._tipiDirittiOneriRiscossioneSource.next(this.tipiDirittiOneriRiscossione);
					console.log("SRV|DS - TIPI DIRITTI ONERI:", this.tipiDirittiOneriRiscossione);
				}
			);
	}

	getTipiSpedizione() {
		this.commonService.getDB().getElementsByTable('tipi_spedizione')
			.subscribe(
				data => { this.tipiSpedizione = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._tipiSpedizioneSource.next(this.tipiSpedizione);
					console.log("SRV|DS - TIPI SPEDIZIONE:", this.tipiSpedizione);
				}
			);
	}

	getTipiNotifica() {
		this.commonService.getDB().getElementsByTable('tipi_notifica')
			.subscribe(
				data => { this.tipiNotifica = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._tipiNotificaSource.next(this.tipiNotifica);
					console.log("SRV|DS - TIPI NOTIFICA:", this.tipiNotifica);
				}
			);
	}

	getEsitiNotifica(){
		this.commonService.getDB().getElementsByTable('esiti_notifica')
			.subscribe(
				data => { this.esitiNotifica = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._esitiNotificaSource.next(this.esitiNotifica);
					console.log("SRV|DS - ESITI NOTIFICA:", this.esitiNotifica);
				}
			);
	}

	getRuoli() {
		this.commonService.getDB().getElementsByTable("livelli")
			.subscribe(
				data => {
					this.ruoli = this.commonService.readDatabaseResponse('',data);
				},
				error => console.log(error),
				() => {
					this._ruoliSource.next(this.ruoli);
					console.log("SRV|DS - RUOLI:", this.ruoli);
				}
			);
	}

	getQualificheAssociato() {
		this.commonService.getDB().getElementsByTable("qualifiche_associato")
			.subscribe(
				data => {
					this.qualificheAssociato = this.commonService.readDatabaseResponse('',data);
				},
				error => console.log(error),
				() => {
					this._qualificheAssociatoSource.next(this.qualificheAssociato);
					console.log("SRV|DS - QUALIFICHE ASSOCIATO:", this.qualificheAssociato);
				}
			);
	}

	getServizi() {
		this.commonService.getDB().getElementsByTable("servizi")
			.subscribe(
				data => {
					this.servizi = this.commonService.readDatabaseResponse('',data);
				},
				error => console.log(error),
				() => {
					this._serviziSource.next(this.servizi);
					console.log("SRV|DS - SERVIZI:", this.servizi);
				}
			);
	}

	getTemplatesGruppi() {
		this.commonService.getDB().getElementsByTable('templates_gruppi')
			.subscribe(
				data => { this.templatesGruppi = this.commonService.readDatabaseResponse('',data); },
				error => console.log(error),
				() => {
					this._templatesGruppiSource.next(this.templatesGruppi);
					console.log("SRV|DS - TEMPLATES GRUPPI:", this.templatesGruppi);
				}
			);
	}

	ricalcolaSanzioni(selectedRow: any, callback: any) {
		let newSelectedRow: any = {};
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		localFilters.push({ type: "=", key: "selectedRow", value: JSON.stringify(selectedRow) });
		this.commonService.getDB().getElementsByQuery('ricalcola_sanzioni', localTable, localFilters, localComuneId)
			.subscribe(
				data => {
					newSelectedRow = this.commonService.readDatabaseResponse('',data);
					newSelectedRow = JSON.parse(newSelectedRow);
				},
				error => console.log(error),
				() => {
					console.log("SRV|DS - RICALCOLO SANZIONI:", newSelectedRow);
					callback(newSelectedRow);
				}
			);
	}
	// SUPPORTO VARIABILI GENERALI

	cambioComune(comuneId: any){
		this.flowInit = true;
		this.comuniService.cambioComune(this.utentiService.getUser(), comuneId);
		console.log("SRV|DS - cambioComune - comune", this.comuniService.getComune());
		this.loadComuneRelative();
		this.getNotificheSistema();
	}
	// FINE SUPPORTO VARIABILI GENERALI
	// FINE GESTIONE VARIABILI GENERALI

	// INIZIO GESTIONE VARIABILI PER COMUNE

	loadComuneRelative() {
		this.openLoader('Setup Comune','Caricamento dei dati relativi al Comune in corso...');
		// PER TUTTI
		this.getFlows();
		this.getEmissioni();
		this.getInteressiMoratori();
		this.getDirittiOneriRiscossioneComuneRelative();
		this.getMessiNotificatori();
		this.getCanaliPagamento();
		this.getResponsabiliTributo();
		this.comuniService.getCittadini();
		this.comuniService.getOperatori(this.utentiService.getUserByComune());

		// PER CITTADINO
		this.getAnagrafica();
		//this.getAnagraficaRel();
		this.getAssociati();
		this.getNotificheUtente();
		this.getAtti();
		this.getLogPratiche();
		this.getPagamenti();
		this.getNotifiche();
		this.getMobili();
		this.getImmobili();
		this.getLocatari();
		this.getDatoriLavoro();
		this.getContiCorrenti();
	}

	getFlows() {
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByTable('flussi_pratica', localComuneId)
			.subscribe(
				data => { this.flows = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._flowsSource.next(this.flows);
					console.log("SRV|DS - FLUSSI:", this.flows);
					this.getActiveFlow();
				}
			);
	}

	getActiveFlow() {
		if(this.flows){
			for (let flow of this.flows) {
				flow.contenuto = JSON.parse(flow.contenuto);
				if (flow.attivo == '1') {
					this.activeFlow = _.cloneDeep(flow);
				}
			}
			this._activeFlowSource.next(this.activeFlow);
			console.log("SRV|DS - ACTIVE FLOW:", this.activeFlow);
			this.setStatesDict();
		}
	}

	setStatesDict() {
		this.statesDictIndex = [];
		this.statesDict = {};
		for(let state of this.activeFlow.contenuto.workflow.states) {
			this.statesDictIndex.push(state.id);
			this.statesDict[state.id] = state;
		}
		this._statesDictSource.next(this.statesDict);
		console.log("SRV|DS - STATES DICT:", this.statesDict);
		this.getPratiche();
	}

	getPratiche() {
		//console.log("SRV|DS - inizio pratiche:");
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		console.log("SRV|DS - comune_id:", localComuneId);
		let permissions = this.utentiService.getPermissions();

		if(!permissions){
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
			console.log('getPratiche|localFilters', localFilters);
		}
		console.log("SRV|DS - PRATICHE PRE:", localTable, localFilters, localComuneId)
		this.commonService.getDB().getElementsByQuery('pratiche', localTable, localFilters, localComuneId)
			.subscribe(
				data => {
					//console.log("SRV|DS - PRATICHE DATA:", data);
					this.pratiche = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [];
				},
				error => { console.log(error); },
				() => {
					for(let pratica of this.pratiche){
						pratica.stato = this.statesDict[pratica.stato].nome;
					}
					this._praticheSource.next(this.pratiche);
					this.getPraticheDettagli();
					console.log("SRV|DS - PRATICHE:", this.pratiche);
				}
			);
	}

	getPraticheDettagli() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("pratiche_dettaglio", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.praticheDettagli = this.commonService.readDatabaseResponse('',data); },
				error => { console.log(error); },
				() => {
					this._praticheDettagliSource.next(this.praticheDettagli);
					console.log("SRV|DS - PRATICHE DETTAGLI:", this.praticheDettagli);
					// this.closeLoader();
				}
			);
	}

	getAtti() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery('atti', localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.atti = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : []; },
				error => { console.log(error); },
				() => {
					this._attiSource.next(this.atti);
					console.log("SRV|DS - ATTI:", this.atti);
				}
			);
	}

	getLogPratiche(){
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("log_pratiche", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.logPratiche = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error) },
				() => {
					if(this.statesDict){
						if(Object.keys(this.statesDict).length){
							for(let pratica of this.logPratiche){
								pratica["stato"] = this.statesDict[pratica.stato_id].nome;
							}
						}
						this._logPraticheSource.next(this.logPratiche);
						console.log("SRV|DS - LOG_PRATICHE:", this.logPratiche);
						this.getLogPraticheDettagli();
					}
				}
			);
	}

	getLogPraticheDettagli(){
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("log_pratiche_dettaglio", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.logPraticheDettagli = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error) },
				() => {
					this._logPraticheDettagliSource.next(this.logPraticheDettagli);
					console.log("SRV|DS - LOG_PRATICHE_DETTAGLI:", this.logPraticheDettagli);
					this.closeLoader();
				}
			);
	}

	getPagamenti() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery('pagamenti', localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.pagamenti = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error); },
				() => {
					this._pagamentiSource.next(this.pagamenti);
					console.log("SRV|DS - PAGAMENTI:", this.pagamenti);
				}
			);
	}

	getCanaliPagamento() {
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByTable('canali_pagamento', localComuneId)
			.subscribe(
				data => { this.canaliPagamento = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error); },
				() => {
					this._canaliPagamentoSource.next(this.canaliPagamento);
					console.log("SRV|DS - CANALI PAGAMENTO:", this.canaliPagamento);
				}
			);
	}

	getEmissioni() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByTable('emissioni', localComuneId)
			.subscribe(
				data => { this.emissioni = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error); },
				() => {
					this._emissioniSource.next(this.emissioni);
					console.log("SRV|DS - EMISSIONI:", this.emissioni);
				}
			);
	}

	getNotifiche() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "pratiche.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("notifiche", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.notifiche = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._notificheSource.next(this.notifiche);
					console.log("SRV|DS - NOTIFICHE:", this.notifiche);
				}
			);
	}

	getMessiNotificatori() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByTable('messi_notificatori', localComuneId)
			.subscribe(
				data => { this.messiNotificatori = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error); },
				() => {
					this._messiNotificatoriSource.next(this.messiNotificatori);
					console.log("SRV|DS - MESSI NOTIFICATORI:", this.messiNotificatori);
				}
			);
	}

	getInteressiMoratori() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByTable('interessi_moratori', localComuneId)
			.subscribe(
				data => { this.interessiMoratori = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error); },
				() => {
					this._interessiMoratoriSource.next(this.interessiMoratori);
					console.log("SRV|DS - INTERESSI MORATORI:", this.interessiMoratori);
				}
			);
	}

	getDirittiOneriRiscossioneComuneRelative() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByQuery("diritti_oneri", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.dirittiOneriRiscossione = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._dirittiOneriRiscossioneSource.next(this.dirittiOneriRiscossione);
					console.log("SRV|DS - DIRITTI ONERI RISCOSSIONE:", this.dirittiOneriRiscossione);
				}
			);
	}

	getAnagrafica(){
		let idComune = this.comuniService.getComuneId();
		let localFilters = [];
		let permissions = this.utentiService.getPermissions();
    console.log('getAnagrafiche|idComune', idComune,'permissions', permissions);

    if(!permissions){
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "anagrafica.anagrafica_id", value: user.id_anagrafica });
			console.log('getAnagrafiche|localFilters',localFilters);
		}
		this.contribuentiService.getAnagrafica(idComune,localFilters);
	}

	getAssociati(){
		let idComune = this.comuniService.getComuneId();
		let localFilters = [];
		let permissions = this.utentiService.getPermissions();
		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "associati.anagrafica_id", value: user.id_anagrafica });
		}
		this.contribuentiService.getAssociati(idComune, localFilters);
	}

	getLocatari() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "anagrafica.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("locatari", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.locatari = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._locatariSource.next(this.locatari);
					console.log("SRV|DS - LOCATARI:", this.locatari);
				}
			);
	}

	getMobili() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "anagrafica.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("beni_mobili", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.beniMobili = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._beniMobiliSource.next(this.beniMobili);
					console.log("SRV|DS - MOBILI:", this.beniMobili);
				}
			);
	}

	getImmobili() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "anagrafica.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("beni_immobili", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.beniImmobili = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._beniImmobiliSource.next(this.beniImmobili);
					console.log("SRV|DS - BENI IMMOBILI:", this.beniImmobili);
				}
			);
	}

	getDatoriLavoro() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "anagrafica.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("datori_lavoro", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.datoriLavoro = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._datoriLavoroSource.next(this.datoriLavoro);
					console.log("SRV|DS - DATORI LAVORO:", this.datoriLavoro);
				}
			);
	}

	getContiCorrenti() {
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		let permissions = this.utentiService.getPermissions();

		if(!permissions) {
			// aggiungere filtro
			let user = this.utentiService.getUser();
			localFilters.push({ type: "=", key: "anagrafica.anagrafica_id", value: user.id_anagrafica });
		}
		this.commonService.getDB().getElementsByQuery("conti_correnti", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.contiCorrenti = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => console.log(error),
				() => {
					this._contiCorrentiSource.next(this.contiCorrenti);
					console.log("SRV|DS - CONTI CORRENTI:", this.contiCorrenti);
				}
			);
	}

	getResponsabiliTributo(){
		let localTable = null;
		let localFilters = [];
		let localComuneId = this.comuniService.getComuneId();
		localFilters.push({ type: "=", key: "livelli_utenti.livello_id", value: "2" });
		this.commonService.getDB().getElementsByQuery("responsabili_tributo", localTable, localFilters, localComuneId)
			.subscribe(
				data => { this.responsabiliTributo = this.commonService.readDatabaseResponse('',data) ? this.commonService.readDatabaseResponse('',data) : [] },
				error => { console.log(error) },
				() => {
					this._responsabiliTributoSource.next(this.responsabiliTributo);
					console.log("SRV|DS - RESPONSABILI TRIBUTO:", this.responsabiliTributo);
				}
			);
	}

	// FINE GESTIONE VARIABILI PER COMUNE

	// INIZIO FUNZIONI DI SERVIZIO

	getStatoCodiceById(id) {
		for (let stato of this.defaultStates) {
			if (stato.id == id) {
				return stato.codice;
			}
		}
	}

	getAttoCodiceByUid(uid, callback) {
		let stato_id = null;
		let codice = null;

		for (let pratica of this.pratiche) {
			if (pratica.id == uid) {
				stato_id = pratica.stato_id;
				break;
			}
		}

		if (stato_id) {
			for (let stato of this.defaultStates) {
				if (stato.id == stato_id) {
					codice = stato.codice;
					break;
				}
			}
		}

		callback(codice);
	}

	getGruppoCodiceByUid(uid, callback) {
		let emissione_id = null;
		let templates_gruppi_id = null;
		let codice = null;

		for (let pratica of this.pratiche) {
			if (pratica.id == uid) {
				emissione_id = pratica.emissione_id;
				console.log('getGruppoCodiceByUid|emissione_id',pratica,emissione_id);
				break;
			}
		}

		if (emissione_id) {
			for (let emissione of this.emissioni) {
				if (emissione.id == emissione_id) {
					templates_gruppi_id = emissione.templates_gruppi_id;
					console.log('getGruppoCodiceByUid|template_gruppi_id',emissione,templates_gruppi_id);
					break;
				}
			}
		}

		if (templates_gruppi_id) {
			for (let gruppo of this.templatesGruppi) {
				if (gruppo.id == templates_gruppi_id) {
					codice = gruppo.codice;
					console.log('getGruppoCodiceByUid|codice',gruppo,codice);
					break;
				}
			}
		}

		callback(codice);
	}

	getStatesIndex() {
		return this.statesDictIndex;
	}

	getNotificheUtenteIndex() {
		return this.getNotificheUtenteIndex;
	}

	setLoading(value: boolean) {
		this.loading = value;
	}

	setPageOpened(value: any){
		this.pageOpened = value;
	}

	insert(table: any, sets = {}, comune_id = true, callback: any = null) {
		let localComuneId = null;
		let localSets: any = sets;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().insertElement(table, localSets, localComuneId)
			.subscribe(
				data => {
					let newId = this.commonService.readDatabaseResponse('insert', data);
					this.refreshData(table);
					if (callback) {
						callback(null, newId);
					}
				},
				error => {
					console.log(error);
					if (callback) {
						callback(error,null);
					}
				}
			);
	}

	insertFlow(sets: any, callback: any = null) {
		let localSets = sets;
		this.commonService.getDB().insertFlow(localSets)
			.subscribe(
				data => {
					let newId = this.commonService.readDatabaseResponse('insert', data);
					if (callback) {
						callback(null, newId);
					}
				},
				error => {
					console.log(error);
					if (callback) {
						callback(error,null);
					}
				}
			);
	}

	insertPagamento(uid: any = null, sets = {}, comune_id = true, callback: any = null) {
		let localComuneId = null;
		let localSets = sets;
		localSets["uid"] = uid;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		this.insert("pagamenti", localSets, localComuneId, (error, newId) => {
			if(error){
				this.openMessage("INSERIMENTO PAGAMENTO", "si è verifcato un errore");
				callback(error,newId);
			}
			if(newId){
				//this.controllaPagatoPratica(uid, [], {}, localComuneId);
				callback(error,newId);
				this.refreshData("pagamenti");
			}
		});
	}

	getElementsByKey(table: any, what = "false", key = "all", comune_id = true, callback: any = null) {
		let result : any;
		let localComuneId = null;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByKey(table, what, key, localComuneId)
			.subscribe(
				data => { result = this.commonService.readDatabaseResponse('',data) },
				error => {
					console.log(error);
				},
				() => {
					if (callback) {
						callback(result);
					}
				}
			);
	}

	update(table: any, filters = [], sets = {}, comune_id = true, callback: any = null) {
		let localComuneId = null;
		let localFilters: any = filters;
		let localSets: any = sets;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		let titleMessage = "ESECUZIONE AGGIORNAMENTO";
		let contentMessage = "Aggiornamento "+table+" non completato, si è verificato un errore!";
		this.commonService.getDB().updateElement(table, localFilters, localSets, localComuneId)
			.subscribe(
				data => {
					let res: any = {};
					res['data'] = this.commonService.readDatabaseResponse('update', data);
					console.log("SRV|DS - AGGIORNATE:", res.data.numRows);
					if (callback) {
						callback(null,res);
					}
					this.refreshData(table);
				},
				error => {
					this.openMessage(titleMessage, contentMessage);
					console.log(error);
					if (callback) {
						callback(error, null);
					}
					this.refreshData(table);
				}
			);
	}

	getScadenzaPerStato(params: any){
		for(let state_id of this.activeFlow.contenuto.workflow.connections[params.partenza_stato]){
			//console.log("stato:", state_id);
			if(this.activeFlow.contenuto.stateSettings[state_id].delayValue != 0){
				params.prossimo_stato = state_id;
				params.numero_scadenza = this.activeFlow.contenuto.stateSettings[state_id].delayValue;
				//console.log("stato delayValue:", state_id, this.activeFlow.contenuto.stateSettings[state_id].delayValue);
			}
		}
	}

	updateNotifica(uid: any = null, filters = [], sets: {}, comune_id = true, callback: any = null) {
		let localComuneId = null;
		let localFilters: any = filters;
		let localSets: any = sets;
		localFilters.push({ type: "=", key: "uid", value: uid });
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		this.getAttiByUid(uid, (atti) => {
			let atto = null;
			let params: any = {
				numero_scadenza: 0,
				notifica_data: new Date(localSets.notifica_data),
				partenza_stato: 0,
				prossimo_stato: 0,
			};
			if(atti.length){
				atto = atti[0];
				params.partenza_stato = atto.stato_id;
				this.getScadenzaPerStato(params);
				console.log("SRV|DS - UPDATENOTIFICA", params);
			}

			let formatter = this.getCommon().getLocale();
			localSets.notifica_scadenza = formatter.toInternetString(formatter.addDate(params.notifica_data, 'days', params.numero_scadenza));
			console.log("updateNotifica", localSets);
			this.update("notifiche", localFilters, localSets, localComuneId, (err,result) => {
				if (err) {
					console.log('updateNotifica|error',err);
				}
				else {
					console.log('updateNotifica|success',result);
					this.controllaScadenzaPratica(uid, params.partenza_stato, params.prossimo_stato, localComuneId);
				}
			});
		});
	}

	delete(table: any, filters = [], comune_id = true, callback: any = null) {
		let localComuneId = null;
		let localFilters: any = filters;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		console.log(table, filters, comune_id);
		let user = this.utentiService.getUser();
		let res: any = {};
		let titleMessage = "ESECUZIONE ELIMINAZIONE";
		let contentMessage = "Eliminazione "+table+" non completato, si è verificato un errore!";
		this.commonService.getDB().deleteElement(table, localFilters, localComuneId)
			.subscribe(
				data => {
					console.log("SRV|DS - DELETE SUCCESS", data, this.commonService.readDatabaseResponse('delete', data));
					res['data'] = this.commonService.readDatabaseResponse('delete', data);
					console.log("SRV|DS - ELIMINATE:", res.data.numRows);
					this.commonService.getDB().socketService.addActivity(user.id, localComuneId, "delete=", "filters="+JSON.stringify(localFilters), true);
					if (callback) {
						callback(null,res);
					}
					this.refreshData(table);
				},
				error => {
					console.log("SRV|DS - DELETE ERROR");
					this.openMessage(titleMessage, contentMessage);
					console.log(error);
					if (callback) {
						callback(error, null);
					}
					this.refreshData(table);
				}
			);
	}

	runQuery(name: any, filters = [], sets = {}, comune_id = true, callback: any = null) {
		let localComuneId = null;
		let localFilters: any = filters;
		let localSets: any = sets;
		let titleMessage = "ESECUZIONE OPERAZIONE";
		let contentMessage = name+" non completata, si è verificato un errore!";
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		let user = this.utentiService.getUser();
		localFilters.push({ type: "who", key: "who", value: user.id })
		this.commonService.getDB().socketService.addActivity(user.id, localComuneId, "runQuery=", name+"?filters="+JSON.stringify(localFilters), true);

		this.commonService.getDB().runQuery(name, localFilters, localSets, localComuneId)
			.subscribe(
				data => {
					let res: any = {};
					let comuneId = "'NULL'";
					res['data'] = this.commonService.readDatabaseResponse('',data);
					console.log("SRV|DS - RUN-QUERY RESPONSE", res, JSON.stringify(localFilters));
					if (callback) {
						callback(null, res);
					}
					console.log("SRV|DS -  refreshData:", name);
					this.refreshData(name);
				},
				error => {
					this.openMessage(titleMessage, contentMessage);
					console.log(error);
					if (callback) {
						callback(error, null);
					}
					this.refreshData(name);
				}
			);
	}

	refreshData(table: any) {
		console.log('SRV|DS - REFRESH DATA', table);
		switch (table) {
			case 'anagrafica':
				this.getAnagrafica();
				//this.contribuentiService.getAnagraficaRel();
				this.getAssociati();
				break;
			case 'atti':
				this.getAtti();
				this.getPratiche();
				this.getLogPratiche();
				break;
			case 'notifiche':
				this.getAtti();
				this.getPratiche();
				this.getLogPratiche();
				this.getNotifiche();
				break;
			case 'avanza_pratica':
				this.getAtti();
				this.getPratiche();
				this.getLogPratiche();
				break;
			case 'cambia_stato':
				this.getPratiche();
				this.getLogPratiche();
				break;
			case 'canali_pagamento':
				this.getCanaliPagamento();
				break;
			case 'comuni':
				this.comuniService.getComuniDisponibili(this.utentiService.getUserByComune());
				break;
			case 'diritti_oneri':
				this.getDirittiOneriRiscossioneComuneRelative();
				break;
			case 'esiti_notifica':
				this.getEsitiNotifica();
				break;
			case 'flussi_pratica':
				this.getFlows();
				break;
			case 'interessi_legali':
				this.getInteressiLegali();
				break;
			case 'interessi_moratori':
				this.getInteressiMoratori();
				break;
			case 'messi_notificatori':
				this.getMessiNotificatori();
				break;
			case 'livelli':
				this.getRuoli();
				break;
			case 'pagamenti':
				this.getPratiche();
				this.getAtti();
				this.getLogPratiche();
				this.getPagamenti();
				break;
			case 'pratiche':
				this.getPratiche();
				this.getLogPratiche();
				this.getAtti();
				this.getEmissioni();
				break;
			case 'pratiche_dettaglio':
				this.getPratiche();
				break;
			case 'restore_pratica':
				this.getAtti();
				this.getPratiche();
				this.getLogPratiche();
				break;
			case 'stati':
				this.getDefaultStates();
				break;
			case 'utenti':
				this.comuniService.getCittadini();
				this.comuniService.getOperatori(this.utentiService.getUserByComune());
				break;
			case 'utenti_livelli':
				this.getRuoli();
				break;
			case 'tipi_tributo':
				this.getTipiTributo();
				break;
			case 'tipi_spedizione':
				this.getTipiSpedizione();
				break;
			case 'tipi_notifica':
				this.getTipiNotifica();
				break;
			case 'qualifiche_associato':
				this.getQualificheAssociato();
				break;
			case 'tipi_fase':
				this.getTipiFase();
				break;
			case 'notifiche_sistema':
				this.getNotificheSistema();
				break;
		}
	}

	controllaScadenzaPratica(uid: any, partenza_stato: number, prossimo_stato: number, comune_id = true){
		let localFilters = [];
		let localSets = {};
		let localComuneId = null;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		localFilters.push({ type: "=", key: "stato_id", value: prossimo_stato });
		localFilters.push({ type: "=", key: "uid", value: uid });
		localFilters.push({ type: "=", key: "mantieni_dati", value: true });

		let oggi_data = new Date();
		let scadenza_date = null;
		this.getAttiByUid(uid, (atti) => {
			let atto = null;
			if(atti.length){
				atto = atti[0];
				console.log("controllaScadenzaPratica atto:", atto);
				scadenza_date = new Date(atto.notifica_scadenza);
				console.log("controllaScadenzaPratica", atto);
				this.refreshData("atti");
				if(scadenza_date < oggi_data){
					this.runQuery("cambia_stato", localFilters, localSets, localComuneId);
					if(prossimo_stato == 6){
						localFilters = [];
						localSets = {};
						localFilters.push({ type: "=", key: "uid", value: uid })
						this.runQuery("aggiorna_oneri_ingiunzione_scaduta", localFilters, localSets, localComuneId, () => {
							console.log("controllaScadenzaPratica ING SCADUTA");
							this.refreshData("pratiche");
						});
					}
					console.log("controllaScadenzaPratica passa a", prossimo_stato);
				}else{
					console.log("controllaScadenzaPratica non passa");
				}
			}
		});
	}

	controllaPagatoPratica(uid: any, filters = [], sets = {}, comune_id = true){
		let localFilters = filters;
		let localSets = sets;
		localFilters.push({ type: "=", key: "id", value: uid });
		let localComuneId = null;
		if(comune_id)
			localComuneId = this.comuniService.getComuneId();
		let pagato_stato = 4;
		let scartoPagato = 0;
		this.getPraticaById(uid, (localPratica) => {
			let datiPratica = localPratica;
			localFilters.push({ type: "=", key: "stato_id", value: pagato_stato });
			localFilters.push({ type: "=", key: "uid", value: uid });
			localFilters.push({ type: "=", key: "mantieni_dati", value: false });
			//console.log("controllaPagatoPratica", datiPratica);
			if(datiPratica){
				scartoPagato = Math.abs(datiPratica.totale_dovuto - datiPratica.totale_pagato);
				if(scartoPagato <= 12){
					this.runQuery("cambia_stato", localFilters, localSets, localComuneId);
					localSets = { riferimento_pagato: datiPratica.stato_id };
					this.update("pratiche", localFilters, localSets, localComuneId, (error, res) => {
						console.log("pagato ok:", scartoPagato);
					});
				}
				else{
					console.log("pagato non basta:", scartoPagato);
				}
			}
		});
	}

	getPraticaById(uid: any, callback) {
		let local_pratica = null;
		//console.log("getPraticaById", uid, this.pratiche);
		for (let pratica of this.pratiche) {
			if (pratica.id == uid) {
				local_pratica = _.cloneDeep(pratica);
			}
		}
		callback(local_pratica);
	}

	getPraticaByIdPrat(id_prat: any, callback) {
		let local_pratica = null;
		//console.log("getPraticaByIdPrat", id_prat, this.pratiche);
		for (let pratica of this.pratiche) {
			if (pratica.id_prat == id_prat) {
				local_pratica = _.cloneDeep(pratica);
				break;
			}
		}
		callback(local_pratica);
	}

	getPraticheByPersonId(id: any, callback: any) {
		let pratiche: any[] = [];
		for (let pratica of this.pratiche) {
			//console.log("pratica", pratica, " id ", id);
			if (pratica.anagrafica_id == id) {
				pratiche.push( _.cloneDeep(pratica) );
			}
		}
		callback(pratiche);
	}

	getDettagliByUid(uid: any, callback: any) {
		let dettagli: any[] = [];
		for (let dettaglio of this.praticheDettagli) {
			//console.log("dettaglio.uid", dettaglio.uid, " uid:", uid);
			if (dettaglio.uid == uid) {
				dettagli.push( _.cloneDeep(dettaglio) );
			}
		}
		callback(dettagli);
	}

	getPersonById(anagrafica_id: any, callback: any) {
		this.contribuentiService.getPersonById(anagrafica_id, callback);
	}

	getAttiByUid(uid: any, callback: any) {
		//console.log('getAttiByUid', uid, this.atti);
		let atti: any[] = [];
		for (let atto of this.atti) {
			if (atto.uid == uid) {
				atti.push( _.cloneDeep(atto) );
			}
		}

		callback(atti);
	}

	getDocumentsByUid(uid: any, callback: any) {
		//console.log('getDocumentsByUid', uid, this.logPratiche);
		let documenti: any[] = [];
		for (let log of this.logPratiche) {
			if (log.uid == uid && log.nome_file) {
				documenti.push( _.cloneDeep(log) );
			}
		}
		for (let atto of this.atti) {
			if (atto.uid == uid && atto.nome_file) {
				documenti.push( _.cloneDeep(atto) );
			}
		}

		callback(documenti);
	}

	getPagamentiByUid(uid: any, callback: any) {
		//console.log('getPagamentiByUid', uid, this.pagamenti);
		let pagamentiTrovati: any[] = [];
		for (let pagamento of this.pagamenti) {
			if (pagamento.uid == uid) {
				pagamentiTrovati.push( _.cloneDeep(pagamento) );
			}
		}
		//console.log('getPagamentiByUid pagamentiTrovati:', pagamentiTrovati);
		callback(pagamentiTrovati);
	}

	getEmissioneById(id: any) {
		//console.log('getEmissioneById', uid, this.emissioni);
		for (let emissione of this.emissioni) {
			if (emissione.id == id) {
				return _.cloneDeep(emissione);
			}
		}
		return null;
	}

	getCanalePagamentoById(id: any) {
		for (let canale of this.canaliPagamento) {
			if (canale.id == id) {
				return _.cloneDeep(canale);
			}
		}
		return null;
	}

	getMobiliByPersonId(idPerson: any) {
		let beniMobili: any[] = [];
		if(this.beniMobili){
			for (let beneMobile of this.beniMobili) {
				if (beneMobile.anagrafica_id == idPerson) {
					beniMobili.push( _.cloneDeep(beneMobile) );
				}
			}
		}
		return beniMobili;
	}

	getImmobiliByPersonId(idPerson: any) {
		let beniImmobili: any[] = [];
		if(this.beniImmobili){
			for (let beneImmobile of this.beniImmobili) {
				if (beneImmobile.anagrafica_id == idPerson) {
					beniImmobili.push( _.cloneDeep(beneImmobile) );
				}
			}
		}
		return beniImmobili;
	}

	getLocatariByPersonId(idPerson: any) {
		let locatari: any[] = [];
		if(this.locatari){
			for (let locatario of this.locatari) {
				if (locatario.anagrafica_id == idPerson) {
					locatari.push( _.cloneDeep(locatario) );
				}
			}
		}
		return locatari;
	}

	getLogPraticheByUid(uid: any){
		let logPratiche: any[] = [];
		if(this.logPratiche){
			for (let logPratica of this.logPratiche) {
				//console.log(logPratica.uid, " log_prat: ", uid);
				if (logPratica.uid == uid) {
					logPratiche.push( _.cloneDeep(logPratica) );
				}
			}
		}
		return logPratiche;
	}

	getFlowById(id: any) {
		for (let flow of this.flows) {
			if (flow.id == id) {
				return _.cloneDeep(flow);
			}
		}
		return null;
	}

	getTemplatesGruppiByUid(uid: any) {
		for (let pratica of this.pratiche) {
			if (pratica.id == uid) {
				for (let emissione of this.emissioni) {
					if (emissione.id == pratica.emissione_id) {
						for (let gruppo of this.templatesGruppi) {
							if (gruppo.id == emissione.templates_gruppi_id) {
								return _.cloneDeep(gruppo);
							}
						}
					}
				}
			}
		}
	}

	getNotificheUtente(){
		let localComuneId = this.comuniService.getComuneId();
		this.commonService.getDB().getElementsByTable('notifiche_utente', localComuneId)
			.subscribe(
				data => { this.notificheUtente = this.commonService.readDatabaseResponse('',data); },
				error => console.log(error),
				() => {
					this.notificheUtenteDictIndex = [];
					this.notificheUtenteDict = {};
					if(this.notificheUtente){
						for(let notUtente of this.notificheUtente){
							if(this.notificheUtenteDict.hasOwnProperty(notUtente.utente)){
								this.notificheUtenteDictIndex.push(notUtente.utente);
								this.notificheUtenteDict[notUtente.utente].push(notUtente);
							}else{
								this.notificheUtenteDictIndex.push(notUtente.utente);
								this.notificheUtenteDict[notUtente.utente] = [ notUtente ];
							}
						}
					}
					this._notificheUtenteDictSource.next(this.notificheUtenteDict);
					console.log("SRV|DS - NOTIFICHE_UTENTE:", this.notificheUtenteDict);
				}
			);
	}

	getAnagraficaRelById(id: any) {
		this.contribuentiService.getAnagraficaRelById(id);
	}

	getLogPraticaDettagliByLogPraticaId(log_pratica_id: any){
		let logPraticheDettagli: any[] = [];
		for (let logDettaglio of this.logPraticheDettagli) {
			//console.log(logDettaglio.log_pratica_id, " log_pratica_id: ", log_pratica_id);
			if (logDettaglio.log_pratica_id == log_pratica_id) {
				logPraticheDettagli.push( _.cloneDeep(logDettaglio) );
			}
		}
		return logPraticheDettagli;
	}

	getLogPraticaDettagliByLogPratica(log_pratica: any){
		let logPraticheDettagli: any[] = [];
		if(log_pratica){
			if (log_pratica.log_pratica_id == 'ATTUALE')
				this.getDettagliByUid(log_pratica.uid, (localDettagli) => {
					logPraticheDettagli = localDettagli;
				});
			else
				logPraticheDettagli = this.getLogPraticaDettagliByLogPraticaId(log_pratica.log_pratica_id);
			console.log("SRV|DS - LOG_PRATICHE_DETTAGLIO: ", logPraticheDettagli);
		}
		else{
			console.log("SRV|DS - LOG_PRATICHE_DETTAGLIO: NON RIUSCITO");
		}
		return logPraticheDettagli;
	}

	getUserServicesByComuneId(userId: any) {
		let localComuneId = this.comuniService.getComuneId();
		return this.commonService.getDB().getUserServicesByComuneId(userId, localComuneId);
	}

	removePermitted(contribuente: any){
		let praticheBoolean = this.getPraticheBooleanByPersonId(contribuente.anagrafica_id);
		let contribuentiBoolean = this.hasAssociatoByPersonId(contribuente.anagrafica_id);
		return !(praticheBoolean && contribuentiBoolean);
	}

	getPraticheBooleanByPersonId(idPerson: any){
		//console.log("getPraticheBooleanByPersonId", idPerson);
		for (let pratica of this.pratiche) {
			if (pratica.anagrafica_id == idPerson) {
				return false;
			}
		}
		return true;
	}

	hasAssociatoByPersonId(idPerson: any){
		this.contribuentiService.hasAssociatoByPersonId(idPerson);
	}

	// FINE FUNZIONI DI SERVIZIO

	getStateConnectionsById(id) {
		return this.activeFlow.contenuto.workflow.connections[id];
	}

	// MESSAGGI
	openMessage(title, content) {
		this.messageTitle = title;
		this.messageContent = content;
		this.showMessage = true;
	}

	closeMessage() {
		this.showMessage = false;
		this.messageTitle = '';
		this.messageContent = '';
	}

	// LOADER
	openLoader(title, content) {
		console.debug("SRV|DS - OPENLOADER");
		this.loaderTitle = title;
		this.loaderContent = content;
		this.showLoader = true;
	}

	closeLoader() {
		console.debug("SRV|DS - CLOSELOADER", this.showLoader);
		this.showLoader = false;
		this.loaderTitle = '';
		this.loaderContent = '';
		console.debug("SRV|DS - CLOSELOADER", this.showLoader);
	}

	// CONFIRM
	openConfirm(title, content, callbackYes = null, callbackNo = null) {
		this.confirmTitle = title;
		this.confirmContent = content;
		this.confirmResponse = null;
		this.showConfirm = true;
		this.callbackConfirmYes = callbackYes;
		this.callbackConfirmNo = callbackNo;
	}

	closeConfirm() {
		this.showConfirm = false;
		this.confirmTitle = '';
		this.confirmContent = '';
		console.log("closeConfirm", this.confirmResponse);
		if(this.confirmResponse && this.callbackConfirmYes) {
			this.callbackConfirmYes();
		} else if (!this.confirmResponse && this.callbackConfirmYes) {
			this.callbackConfirmNo();
		}

	}

	lockApp(reason) {
		console.log('LOCK APP');
		this.appLocked = true;
		this.lockReason = reason;
	}

	unlockApp() {
		console.log('UNLOCK APP');
		this.appLocked = false;
		this.lockReason = '';
	}

	addNotificaSistema(notifica){
		console.log('pre add notifica',notifica,this.utentiService.getPermissions())
		if ( notifica.comune_id != notifica.user_id || (notifica.comune_id == notifica.user_id && this.utentiService.getPermissions()) ) {
			notifica['data'] = Date.now()
			this.notificheSistema.push(notifica);
			this._notificheSistemaSource.next(this.notificheSistema);
			if (Notification.permissions != "granted") {
				Notification.requestPermission(function(){
					new Notification(notifica.testo,{icon:notifica.icon});
				});
			}
			else {
				new Notification(notifica.testo);
			}
		}
	}

	exportCsv(filename: string, data: any){
		this.commonService.exportCsv(filename, data);
	}

	setTitlePage(titlePath: string){
		var titlePage = "";
		var titlePageArray = titlePath.split("/");
		titlePage = titlePageArray[1];
		titlePage = titlePage.split("-").join(" ");
		titlePage = this.commonService.titleCase(titlePage);
		//console.log("SRV|DS - titlePage", titlePage);
		this.titlePage = titlePage;
	}

	checkPermission(key, permission, filter){
		let localComuneId = this.comuniService.getComuneId();
		let possibile = this.utentiService.checkPermission(localComuneId, key, permission, filter);
		if(this.appLocked && permission == 'write') {
			possibile = possibile && false;
		}
		return possibile;
	}

	getNotificheSistema() {
		let comuniIds = [];
		if(this.utentiService.getUser()){
			if(this.comuniDisponibili.length){
				for(let comune of this.comuniDisponibili){
					comuniIds.push(comune.id);
				}
				if(comuniIds.length){
					this.utentiService.getSystemNotifications(comuniIds).subscribe(
						data => {
							//console.log('SRV|DS - getNotificheSistema data', data);
							if(!data.error){
								this.notificheSistema = data.rows;
								console.log('SRV|DS - getNotificheSistema', this.notificheSistema);
								this._notificheSistemaSource.next(this.notificheSistema);
							}
						},
						err => {
							console.log("Error occured:", err);
						}
					);
				}
			}
		}
	}

	setNotificaRead(notifica) {
		this.commonService.getDB().setNotificaRead(notifica)
			.subscribe(
				data => {
					console.log('DBS|setNotificaRead',data);
					this.refreshData('notifiche_sistema')
				}
			);
	}

	openNewRate(event) {
		this.avanzaPratiche(null, null, event.uid);
		this.commonService.nextStep.preselected = event.preselected;
		this.commonService.nextStep.locked = true;
		return this.commonService.nextStep;
	}

	avanzaPratiche(praticheFiltered: any[], idStatoAttuale: number, uid: number = null) {
		console.log('SRV|DS', praticheFiltered, idStatoAttuale, uid);
		this.commonService.nextStep.numPrat = 0;
		this.commonService.nextStep.idStatoAttuale = idStatoAttuale;
		this.commonService.nextStep.comuneId = this.comuniService.getComuneId();
		this.commonService.nextStep.codiceComune = this.comuniService.getComuneCodice();
		this.commonService.nextStep.nomeComune = this.comuniService.getComuneNome();
		this.commonService.nextStep.uids = [];

		if (uid) {
			console.log('PRATICA SINGOLA', uid);
			this.commonService.nextStep.uids.push(uid);
			this.commonService.nextStep.primoAtto = uid;
			this.commonService.nextStep.ultimoAtto = uid;
			this.commonService.nextStep.numPrat = 1;
		}else {
			let praticheOrdered = _.orderBy(praticheFiltered,['id_prat'],['asc']);
			//console.log('ORDINATE', praticheOrdered);
			for (let row of praticheOrdered) {
				this.commonService.nextStep.uids.push(row.id);
				this.commonService.nextStep.numPrat++;
			}
			this.commonService.nextStep.primoAtto = praticheOrdered[0].id_prat;
			this.commonService.nextStep.ultimoAtto = praticheOrdered[(praticheOrdered.length -1)].id_prat;
		}
		return this.commonService.nextStep;
	}
}
